var $body,
    $header,
    scrollingHeaderHeight = 64,
    $sticky,
    $footerSubmenus,
    $menuMobileToggle,
    $mobileMenu,
    $counterItems,
    bodyScrollY = 0,
    bodyScrollUpdateTicking = false,
    bodyScrollVisibleUpdateTick = false,
    $pageMenuToggle,
    $pageMenuContainer,
    $toggleShare,
    $toggleAccordion,
    $searchOpen,
    $searchClose,
    $search,
    $playVideo,
    $toggleChat,
    $toggleChatIframe,
    $dataToggle,
    $dataToggleContent,
    $toggleFoldout,
    $activeAccordionRow,
    $toggleProgram,
    $congresMenuItems;

// Variables for the scroll up/down detection
var didScroll,
    lastScrollTop = 0,
    delta = 5,
    navbarHeight;


$(document).ready(function($) {

    console.log('%cLinku Novio',"font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    /* -----------------------------------
    | Get elements
    * ----------------------------------- */
    $body = $('body');
    $dataToggle         = $('.js-datadisplay-toggle');
    $dataToggleContent  = $('.js-datadisplay-toggle-content');
    $header             = $('.js-header');
    $sticky             = $('.js-sticky');
    $footerSubmenus     = $('.js-toggle-mobile-submenu');
    $menuMobileToggle   = $('.js-toggle-mobile-menu');
    $mobileMenu         = $('.js-mobile-menu');
    $counterItems       = $('.js-counter-item');
    $pageMenuToggle     = $('.js-toggle-submenu');
    $pageMenuContainer  = $('.js-toggle-container');
    $toggleShare        = $('.js-toggle-share');
    $toggleFoldout      = $('.js-toggle-foldout');
    $toggleAccordion    = $('.js-toggle-accordion');
    $activeAccordionRow = $('.js-active-row');

    $toggleProgram    = $('.js-toggle-program');
    $searchOpen       = $('.js-open-search');
    $searchClose      = $('.js-close-search');
    $search           = $('.js-search');
    $congresMenuItems = $('.c-menu--congress .c-menu__link');
    $playVideo        = $('.js-play');
    $toggleChat       = $('.js-toggle-chat');
    $toggleChatIframe = $('.js-chat-iframe');

    navbarHeight = $header.outerHeight();

    /* -----------------------------------
     | Startup functions
     * ----------------------------------- */
    handleFooterMobileToggle();
    handleMenuMobileToggle();
    checkScroll();
    requestBodyScrollUpdate();
    checkIfVisible();
    initImageSlider();
    initQuoteSlider();

    /* -----------------------------------
     | Event listeners
     * ----------------------------------- */
    // Add background to menu on scroll
    $(window).on('scroll', function () {
        didScroll = true;
        checkScroll();
        requestBodyScrollUpdate();
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    $pageMenuToggle.on('click', function(){
        $pageMenuContainer.slideToggle();
        $(this).toggleClass('is-open');
    });

    $toggleShare.on('click', function(e) {
        event.stopPropagation();
        $(this).toggleClass('is-open');
    });

    $toggleChat.on('click', function() {
        console.log('toggle')
        $(this).toggleClass('is-open');

        $toggleChatIframe.slideToggle();
    });

    $(window).click(function() {
        $toggleShare.removeClass('is-open');
    });

    $toggleFoldout.on('click', function() {
        $(this).toggleClass('is-open');

        $(this).next().slideToggle();
    });

    $toggleAccordion.on('click', function(e) {
        e.stopPropagation();
        var $parent = $(this).parent();

        if ($parent.hasClass('is-open')) {
            $parent.removeClass('is-open');
            $(this).next().stop().slideUp();

        } else {
            $toggleAccordion.parent().removeClass('is-open');
            $toggleAccordion.next().stop().slideUp();

            $parent.addClass('is-open');
            $(this).next().stop().slideDown();
        }
    });

    $toggleProgram.on('click', function(e) {
        e.stopPropagation();
        var $parent = $(this).parent();

        if ($parent.hasClass('is-open')) {
            $parent.removeClass('is-open');
            $(this).next().stop().slideUp();

        } else {
            $toggleProgram.parent().removeClass('is-open');
            $toggleProgram.next().stop().slideUp();

            $parent.addClass('is-open');
            $(this).next().stop().slideDown();
        }
    });

    $searchOpen.on('click', function() {
        $search.addClass('is-open');
        $search.find('.js-search-input').focus();
    });

    $searchClose.on('click', function() {
        $search.removeClass('is-open');
    });

    $congresMenuItems.on('click', function(e) {
        e.preventDefault();

        var targetID = $(this).attr('href');
        var $anchor = $(targetID);
        if (typeof $anchor[0] !== "undefined") {
            $anchor[0].scrollIntoView({ block: 'start',  behavior: 'smooth' });
        }

    });

    $dataToggle.on('click', function () {
        var $activeDataDisplay = $(this).parent().find('.js-datadisplay-toggle-content');
        var activeClassName = 'is-open';

        $dataToggleContent.stop().slideUp();

        if ($(this).hasClass(activeClassName)) { // If clicked datadisplay is active
            $(this).removeClass(activeClassName);
            $(this).html('Toon meer');
            $activeDataDisplay.stop().slideUp();
        } else { // If clicked datadisplay is not active
            $(this).addClass(activeClassName);
            $(this).html('Toon minder');
            $activeDataDisplay.stop().slideDown();
        }
    });

    $playVideo.click(function(event) {
        // console.log('click')
        var $targetVideo = $(this).siblings('.js-media');
        // console.log($targetVideo);
        var $iframe = $targetVideo.find('iframe');

        console.log($iframe.src);
        //
        //
        // console.log($iframe[0]);
        // console.log($iframe.src);


        if (!$targetVideo.hasClass('is-playing')) {
            $targetVideo.addClass('is-playing');
            $iframe.src += "&autoplay=1";
            var src = $iframe.attr('src');
            console.log(src);
            $iframe.attr('src', src + "&autoplay=1")
        }
    });

    function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $header.removeClass('is-scrolling-up');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $header.addClass('is-scrolling-up');
            }
        }

        if ($(window).scrollTop() <= 0) {
            $header.addClass('is-on-top');
        } else {
            $header.removeClass('is-on-top');
        }

        lastScrollTop = st;
    }

    function checkScroll() {
        $sticky.each(function() {
            var topOffset = $(window).scrollTop() + scrollingHeaderHeight + 50;
            var childHeight = $(this).find('.js-sticky-container').height();
            var bottomContainer = $(this).offset().top + $(this).height() - childHeight - 50;

            if (topOffset > $(this).offset().top ) {
                if (topOffset > bottomContainer) {
                   $(this).addClass("is-stuck-bottom");
                } else {
                    $(this).addClass("is-sticky");
                    $(this).removeClass("is-stuck-bottom");
                }
            } else {
                $(this).removeClass("is-sticky");
               $(this).removeClass("is-stuck-bottom");
            }
        });
    }

    function handleFooterMobileToggle() {
        $footerSubmenus.click(function() {

            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $(this).next().slideUp();
                return;
            }

            $footerSubmenus.removeClass('is-active');
            $footerSubmenus.next().slideUp();
            $(this).addClass('is-active');
            $(this).next().slideDown();
        });
    }

    function handleMenuMobileToggle() {
        $menuMobileToggle.click(function() {
            $mobileMenu.toggleClass('is-active');
            $menuMobileToggle.toggle();
        });
    }

    function countUp($element) {
        if ($element.hasClass('is-counting')) {
            return;
        }
        $element.addClass('is-counting');
        var countTo = $element.attr('data-count');
        countTo = countTo.replace(/[^0-9]/, '');
        countTo = countTo.replace('.', '');

        $({countNum: $element.text()}).delay(300).animate({
            countNum: countTo
        }, {
            duration: 3000,
            easing: 'linear',
            step: function () {
                $element.text(format(Math.floor(this.countNum)));
            },
            complete: function () {
                $element.text(format(this.countNum));
            }
        });
    }

    $(window).on('resize scroll', checkIfVisible);

    function checkIfVisible(force) {
        if (typeof force === 'undefined') force = false;

        if (force || !bodyScrollVisibleUpdateTick) {
            if ($counterItems.length > 0) {
                $counterItems.each(function () {
                    if ($(this).isInViewport()) {
                        $(this).addClass('is-visible');
                        countUp($(this).find('.js-count'));
                    }
                });
            }
        }
        bodyScrollVisibleUpdateTick = true;
    }

    function requestBodyScrollUpdate(force) {

        if (typeof force === 'undefined') force = false;

        if (force || !bodyScrollUpdateTicking) {
            requestAnimationFrame(function () {
                bodyScrollUpdateTicking = false;
                bodyScrollY = document.documentElement.scrollTop || window.scrollY;
            });
        }
        bodyScrollUpdateTicking = true;
    }

    function format(nStr) {
        nStr += '';
        let x = nStr.split(',');
        let x1 = x[0];
        let x2 = x.length > 1 ? ',' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    function initImageSlider() {
        var $slider = $('.js-image-slider');

        $slider.each(function(index, value) {
            speed = $(this).data('slide-speed');
            tns({
                container: value,
                items: 1,
                slideBy: 1,
                autoplayTimeout: speed,
                nav: false,
                autoplayButtonOutput: false,
                controlsText: ["", ""],
                responsive: {
                    576: {
                        items: 2
                    },
                    992: {
                        items: 4
                    }
                },
                autoplay: true
            });
        });
    }

    function initQuoteSlider() {
        var $slider = $('.js-quote-slider');

        $slider.each(function(index, value) {
            speed = $(this).data('slide-speed');
            tns({
                container: value,
                items: 1,
                slideBy: 1,
                speed: 500,
                autoplayTimeout: speed,
                nav: false,
                autoplayButtonOutput: false,
                controls: false,
                controlsText: ["", ""],
                autoplay: true
            });
        });
    }
});

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top + 200;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};
